export default __webpack_public_path__ + "static/media/nepal_flag.f9f261e7.gif";